export const ROOT = 'https://bugs.channeli.in';
export const API_ROOT = `${ROOT}/api/`;
export const REST_AUTH_LOGIN = `${ROOT}/rest-auth/login/`;
export const OMNIPORT_OAUTH_ROOT = `https://channeli.in/oauth/authorise`;
export const CLIENT_ID = `9pxjY6zusi6g1xDcW1hAcTcpwaPpp9sR52LPmgD5`;
export const DESIRED_STATE = `foobarbaz42`;
export const REDIRECT_URL = `https://bugs.channeli.in/onlogin`;
export const OMNIPORT_OAUTH = `${OMNIPORT_OAUTH_ROOT}/?client_id=${CLIENT_ID}&redirect_url=${REDIRECT_URL}&state=${DESIRED_STATE}`;
export const RICKROLLED = 'https://www.youtube.com/watch?v=dQw4w9WgXcQ';
export const WEBSOCKET_ROOT = 'wss://bugs.channeli.in/ws/';
export const UPDATE_PROJECT_MEMBERS = id => `${API_ROOT}projects/${id}/update-project-members/`;
export const UPDATE_PROJECT_STATUS = id => `${API_ROOT}projects/${id}/update-project-status/`;
export const UPDATE_ISSUE_STATUS = id => `${API_ROOT}issues/${id}/update-issue-status/`;
export const ASSIGN_ISSUE = id => `${API_ROOT}issues/${id}/issue-assign/`;
